import { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { MixpanelContext } from '../../../contexts/MixpanelContext';
import useToggleDetailOverlay from '../../../hooks/useToggleDetailOverlay';
import { useConfigurationSections } from '../../../hooks/useConfiguration';
import { checkShowLockIcon } from '../../../helpers/vod';
import { showUpgradedModal } from '../../../store/reducers/generalConfigurationSlice';
import {
    handleCatchupNavigation,
    handleDefaultNavigation,
    handleRouteNavigation,
} from '../handlers/horizontalBannerHandlers';
import { getHBPromotions, groupHBPromotions, normalizeHBUIData } from '../utils/promotions';
import { handleMixpanelEvents } from '../utils/track';
import { showGuestPromotionPopup } from '../../../guest';

export const usePromotions = ({ content, onClickHandler }) => {
    const promotions = getHBPromotions(content);

    const grouped = groupHBPromotions(promotions);
    const normalized = normalizeHBUIData(grouped, onClickHandler);

    const ppvPromotions = normalized['PPV'] || [];
    const groupedCommon = Object.entries(normalized)
        .filter(([type]) => type !== 'PPV')
        .flatMap(([_, items]) => items);

    return { groupedPromotions: normalized, ppvPromotions, groupedCommon };
};

export const usePromotionClick = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { track } = useContext(MixpanelContext);
    const userChannels = useSelector((state: any) => state.liveTv?.userChannels);
    const { showDetailOverlay, removeSearchParams } = useToggleDetailOverlay();
    const { paidVsFree } = useConfigurationSections();
    const enableLockIcon = paidVsFree?.lockIconEnable || false;

    const openDetailOverlay = (item) => {
        removeSearchParams(['movie', 'series', 'guid', 'season']);
        const itemId = item.Id;
        const typeKey = item.programType === 'movie' ? 'movie' : 'series';
        showDetailOverlay({
            [typeKey]: btoa(itemId),
            guid: btoa(item?.guid),
            season: btoa(item?.tvSeasonNumber || item?.seasonNumber || null),
        });
    };

    const onClickHandler = (item) => {
        if (showGuestPromotionPopup()) {
            return;
        }
        const showDetailsPage = (item) => item?.promoType === 'VOD' || item?.promoType === 'SERIES';
        handleMixpanelEvents(item, track, userChannels);

        if (showDetailsPage(item)) {
            const isLocked = checkShowLockIcon(item?.subscriptionGuids ?? []) && enableLockIcon;
            if (isLocked && !item?.isLocked) {
                dispatch(showUpgradedModal(true));
                return;
            }
            openDetailOverlay(item);
            return;
        }

        if (handleCatchupNavigation({ item, userChannels, navigate })) return;

        if (handleRouteNavigation({ item, navigate })) return;

        handleDefaultNavigation({ item, navigate });
    };

    return { onClickHandler };
};
